import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentApiService } from '@uc/web/config';
import { DegreeQuizResult } from '@uc/web/analytics';
import {
	DegreeQuizOption,
	DegreeQuizQuestionData,
	DegreeQuizRegisterPlatform,
	DegreeQuizRegistrationPayload,
	DegreeQuizSlug,
	DegreeQuizUserAnswer,
} from '../models/degree-quiz.models';
import { CustomCookieService } from '@uc/shared/authentication';

@Injectable({
	providedIn: 'root',
})
export class DegreeQuizApiService {
	constructor(
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
		private _customCookieSrv: CustomCookieService,
	) {}

	getQuizOptions() {
		return this._http.get<DegreeQuizOption[]>(
			`${this._apiSrv.API_URL}degree-quizzes`,
		);
	}

	getQuizById(slug: DegreeQuizSlug) {
		return this._http.get<DegreeQuizQuestionData>(
			`${this._apiSrv.API_URL}degree-quizzes/${slug}`,
		);
	}

	sendQuizResult(quizId: string, answers: DegreeQuizUserAnswer[]) {
		const params = { answers };
		return this._http.post<{ id: string; message: string }>(
			`${this._apiSrv.API_URL}degree-quizzes/${quizId}/results`,
			params,
			{ transferCache: false },
		);
	}

	getQuizResult(resultId: string) {
		const token = this._customCookieSrv.get('token');

		const headers = new HttpHeaders({
			Authorization: `Bearer ${token}`,
		});

		return this._http.get<DegreeQuizResult[]>(
			`${this._apiSrv.API_URL}degree-quizzes/results/${resultId}`,
			{ headers, transferCache: false },
		);
	}

	registerQuizUser(
		data: DegreeQuizRegistrationPayload,
		platform: DegreeQuizRegisterPlatform,
	) {
		const headers = new HttpHeaders({
			Platform: platform,
		});

		return this._http.post<{ message: string; id: string }>(
			`${this._apiSrv.API_URL}register/quick`,
			data,
			{ headers, transferCache: false },
		);
	}
}
